import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { AutorizacionPedidosService } from "src/app/servicios/autorizacion-pedidos.service";
import { TipoAutorizacionService } from "src/app/servicios/tipo-autorizacion.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-dialog-autorizacion-pedidos",
  templateUrl: "./dialog-autorizacion-pedidos.component.html",
  styleUrls: ["./dialog-autorizacion-pedidos.component.css"],
})
export class DialogAutorizacionPedidosComponent implements OnInit {
  autorizaPedidoForm: FormGroup;
  dataAutorizacion: any;
  tiposAutorizacion = [];
  loadingTiposAutorizacion = false;
  loadingCrearAutorizacion = false;
  dataModified = false;
  origen = 0;
  tipoUsuario = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private dialogRef: MatDialogRef<DialogAutorizacionPedidosComponent>,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private servicioTiposAutorizacion: TipoAutorizacionService,
    private servicioAutorizacion: AutorizacionPedidosService
  ) {
    this.dataAutorizacion = dataDialog;
    console.log(JSON.stringify(this.dataAutorizacion));
    this.origen = dataDialog.origen;

    this.autorizaPedidoForm = this.fb.group({
      idTipoAutorizacion: ["", Validators.required],
      observacion: [""],
    });
  }

  ngOnInit(): void {
    this.loadingTiposAutorizacion = true;
    const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
    this.tipoUsuario = infoUsuario[0].IdTpoUsuario;
    this.servicioTiposAutorizacion
      .getAllTipoAutorizacion()
      .subscribe((result) => {
        this.tiposAutorizacion = result;

        if (this.tipoUsuario == 1)
          this.tiposAutorizacion.unshift({ id: 0, valor: "SIN AUTORIZAR" });

        this.loadingTiposAutorizacion = false;
        if (this.origen == 2) {
          this.servicioAutorizacion
            .getAutorizacionPedido(this.dataAutorizacion.documento)
            .subscribe((result) => {
              if (result.length > 0) {
                this.autorizaPedidoForm.controls["idTipoAutorizacion"].setValue(
                  result[0].id
                );
                this.autorizaPedidoForm.controls["observacion"].setValue(
                  result[0].Observacion
                );
              }
            });
        }
      });
  }

  procesaAutorizacion() {
    const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
    const idTipoAutorizacion = this.autorizaPedidoForm.controls[
      "idTipoAutorizacion"
    ].value;
    const observacion = this.autorizaPedidoForm.controls["observacion"].value;

    this.loadingCrearAutorizacion = true;

    if (this.origen == 1) {
      let params = {
        idExEncabezado: this.dataAutorizacion.documento,
        idSucursalVentas: this.dataAutorizacion.idSucursalVentas,
        idExSucursalVentas: this.dataAutorizacion.idExSucursalVentas,
        idTipoAutorizacion: idTipoAutorizacion,
        observacion: observacion,
        idUsuario: infoUsuario[0].IdUsuario,
      };
      this.servicioAutorizacion
        .postAutorizacionPedido(params)
        .subscribe((result) => {
          this.loadingCrearAutorizacion = false;
          this.snackBar.open("Proceso realizado", "Autorizacion pedido", {
            duration: 2000,
          });
          this.dialogRef.close(true);
        });
    } else if (this.origen > 1) {
      let params = {
        idExEncabezado: this.dataAutorizacion.documento,
        idTpoAutorizacion: idTipoAutorizacion,
        observacion: observacion,
        idUsuario: infoUsuario[0].IdUsuario,
      };
      this.servicioAutorizacion
        .putAutorizacionPedidoEstado(
          this.dataAutorizacion.idAutorizacion,
          params
        )
        .subscribe((result) => {
          this.loadingCrearAutorizacion = false;
          this.snackBar.open("Proceso realizado", "Autorizacion pedido", {
            duration: 2000,
          });
          this.dialogRef.close(true);
        });
    }
  }
}
